var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClickSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#d4d4d4",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297 297",
    xmlSpace: "preserve",
    stroke: "#d4d4d4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.685,297c5.345-17.25,22.776-77.344,22.776-99.488v-76.899c0-10.362-8.324-18.793-18.555-18.793 c-10.228,0-18.552,8.431-18.552,18.793v32.79c0,1.927-1.566,3.493-3.492,3.493c-1.927,0-3.492-1.566-3.492-3.493v-51.243 c0-10.359-8.326-18.789-18.558-18.789c-10.23,0-18.553,8.43-18.553,18.789v36.533c0,1.927-1.567,3.492-3.492,3.492 c-1.926,0-3.491-1.566-3.491-3.492V87.455c0-10.358-8.324-18.784-18.555-18.784c-10.229,0-18.552,8.426-18.552,18.784v36.542 c0,1.924-1.568,3.492-3.493,3.492c-1.927,0-3.492-1.568-3.492-3.492V18.788C141.185,8.427,132.859,0,122.627,0 c-10.231,0-18.556,8.427-18.556,18.788V181.7c0,1.449-0.909,2.762-2.266,3.271c-1.345,0.504-2.918,0.103-3.855-0.974l-43.461-49.715 l-0.51-0.529c-3.483-3.296-8.053-5.124-12.863-5.151h-0.124c-5.003,0.058-9.629,1.962-13.025,5.366 c-4.28,4.283-7.634,12.468,0.719,27.156c12.684,22.277,26.547,43.406,38.829,62.122c9.131,13.92,17.757,27.066,24.188,38.154 c4.111,7.096,12.687,25.727,17.429,35.599H250.685z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickSvgrepoCom);
export default __webpack_public_path__ + "static/media/click-svgrepo-com.cc63b9ff14a18ceaa6ef7a6f83b7cf7c.svg";
export { ForwardRef as ReactComponent };